// /coverify route, normalized to use the main CoSec header/footer
// (previously had its own subdomain-style Header/Footer).
import React from "react";
import CosecHeader from "@/components/cosec/Header";
import CosecFooter from "@/components/cosec/Footer";
import Hero from "@/components/coverify/Hero";
import TrustBadges from "@/components/coverify/TrustBadges";
import WhatIs from "@/components/coverify/WhatIs";
import Personas from "@/components/coverify/Personas";
import KeyFeatures from "@/components/coverify/KeyFeatures";
import Benefits from "@/components/coverify/Benefits";
import VerificationFlow from "@/components/coverify/VerificationFlow";
import Integrations from "@/components/coverify/Integrations";
import Differentiators from "@/components/coverify/Differentiators";
import Pricing from "@/components/coverify/Pricing";
import LiveDemo from "@/components/coverify/LiveDemo";
import FAQ from "@/components/coverify/FAQ";

export default function Landing() {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <CosecHeader />
      <Hero />
      <TrustBadges />
      <WhatIs />
      <Personas />
      <KeyFeatures />
      <Benefits />
      <VerificationFlow />
      <Integrations />
      <Differentiators />
      <Pricing />
      <LiveDemo />
      <FAQ />
      <CosecFooter />
    </main>
  );
}
